///用户信息model
import { Provider } from './provider.model';
import { Patient } from './patient.model';

export enum AccountType {
  Patient = 1, //病人
  Provider = 2, //供应商
  Admin = 3// 管理用户
}

export interface User {
  id: string;
  accountType: AccountType;
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
  born?: string;
  gender?: string;
  company?: string;
  job?: string;
  avatar?: any;
  patientRef?: Patient;
  providerRef?: Provider;
}

export enum InviteStatus {
  ACCEPT = 1, 
  REJECT = 2 

}